module.exports = __webpack_public_path__ + "static/media/phone-mask.054b6255.png";